import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import Container from "@mui/material/Container";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import CreateItemButton from "../../components/CreateItemButton.js";
import DataNotFound from "../../components/DataNotFound.js";
import ErrorDialog from "../../components/dialogs/ErrorDialog.js";
import LoadingBackdrop from "../../components/LoadingBackdrop.js";
import PageList from "../../components/page-list/PageList.js";
import { useUser } from "../../components/UserContext.js";
import { getRuns, postRun } from "../../lib/apiConfig.js";
import { PAGE_LIST_CONTAINER_SX, ROUTES } from "../../lib/constants.js";
import { useFetch } from "../../lib/hooks/useFetch.js";
import CreateRunDialog from "./components/dialogs/CreateRunDialog.js";

export default function RunsList({ locales }) {
  const { runId } = useUser();
  const navigate = useNavigate();
  const [runs, setRuns] = useState(null);
  const [runName, setRunName] = useState("");
  const [showCreateRunDialog, setShowCreateRunDialog] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const setError = (error) => {
    setErrorMessage(error.message);
    setShowError(true);
  };

  const { isFetching: isFetchingRuns } = useFetch({
    endpoint: getRuns(),
    mustFetch: !runs,
    onSuccess: setRuns,
    onFail: setError,
  });

  const { fetchData: createRun, isFetching: isCreatingRun } = useFetch({
    endpoint: postRun({ runId }),
    onSuccess: (response) => {
      const runId = response.id;

      navigate(`/${ROUTES.RUNS.DETAIL.replace(":id", runId)}`, {
        replace: true,
        state: { id: runId },
      });
    },
    onFail: setError,
  });

  const handleCreateRunClick = () => {
    setShowCreateRunDialog(false);
    createRun({ name: runName });
  };

  return isFetchingRuns || isCreatingRun ? (
    <LoadingBackdrop />
  ) : (
    <Container disableGutters sx={PAGE_LIST_CONTAINER_SX}>
      <CreateItemButton
        icon={<PlaylistAddIcon />}
        onClick={() => setShowCreateRunDialog(true)}
        text={locales["runs.create"]}
      />
      {Array.isArray(runs) ? (
        <PageList
          items={runs}
          locales={locales}
          pageName="runs"
          primaryTextProp="name"
          searchBoxLabel={locales["runs.search"]}
        />
      ) : (
        <DataNotFound text={locales["runs.notFound"]} />
      )}
      <CreateRunDialog
        locales={locales}
        onInput={({ target }) => {
          setRunName(target.value?.replaceAll(" ", ""));
        }}
        onClose={() => {
          setShowCreateRunDialog(false);
          setRunName("");
        }}
        onConfirm={handleCreateRunClick}
        name={runName}
        show={showCreateRunDialog}
      />
      <ErrorDialog
        locales={locales}
        message={errorMessage}
        onClose={() => {
          setShowError(false);
          setErrorMessage(null);
        }}
        show={showError}
      />
    </Container>
  );
}
